import React, { FunctionComponent } from 'react'

import styled from 'styled-components/native'

import { S4CLoadingAnimationDesktop, S4CLoadingAnimationMobile } from '../../assets'
import { IS_WEB } from '../../constants'
import { tID } from '../../utils'
import { Image } from '../image/Image'

const ImageContainer = styled(Image)<{ size: string }>(({ size }) => ({
  width: size,
  height: size,
}))

/**
 * Illustration to show on Search For Care - Provider Preferences, when
 * loading location-based search results.
 */
export const S4CLoadingAnimation: FunctionComponent<S4CLoadingAnimationProps> = ({ size = 256 }) => {
  const sizeInPixels = `${size}px`
  return (
    <ImageContainer
      dataSet={{ chromatic: 'ignore' }}
      size={sizeInPixels}
      testID={`${tID('S4CLoadingAnimation')}`}
      source={IS_WEB ? S4CLoadingAnimationDesktop : S4CLoadingAnimationMobile}
    />
  )
}

type S4CLoadingAnimationProps = {
  size?: number
}
